import React, { FC, ReactNode } from 'react'

import styles from './styles.module.css'

export interface AccordionButtonProps {
  handleOnClick: () => void
  isOpen: boolean
  isLastChild?: boolean
  children: ReactNode
  isBottomAligned?: boolean
  noPadding?: boolean
  noBorderWhenOpen?: boolean
  smallTitle?: boolean
}

const AccordionButton: FC<AccordionButtonProps> = ({
  handleOnClick,
  isOpen,
  isLastChild = false,
  children,
  isBottomAligned = false,
  noPadding = false,
  noBorderWhenOpen = false,
  smallTitle = false
}) => {
  return (
    <button
      className={styles.button}
      data-is-open={isOpen}
      data-is-last={isLastChild}
      data-is-bottom-aligned={isBottomAligned}
      data-no-padding={noPadding}
      data-no-border-when-open={noBorderWhenOpen}
      data-small-title={smallTitle}
      onClick={handleOnClick}
      tabIndex={0}
    >
      {children}
      <svg className={styles.icon}>
        <use xlinkHref='/icons.svg#icon-chevron-up_1' />
      </svg>
    </button>
  )
}

export default AccordionButton
